/**
 * Shared attachment data contract.
 *
 * This is a UI-agnostic data shape used across apps and UI components.
 * `@f2e/ui` components re-export these types for backward compatibility.
 */
export const FileAttachmentScope = {
    Persistent: "persistent",
    Ephemeral: "ephemeral",
};
export const FileAttachmentType = {
    File: "file",
    ContextObject: "context_object",
    WebContent: "web_content",
    PageSnapshot: "page_snapshot",
};
